import { Player, ControlBar, BigPlayButton } from 'video-react';
import React from 'react';
import './RedQuickVideo.scss';

/// https://video-react.js.org/components/player/
export interface RedQuickVideoState {
    duration: number,
    currentTime: number,
    seekingTime: number,
    buffered: any,
    waiting: boolean,
    seeking: boolean,
    paused: boolean,
    autoPaused: boolean,
    ended: boolean,
    playbackRate: number
    muted: boolean,
    volume: number,
    readyState: any,
    networkState: any,
    videoWidth: number,
    videoHeight: number,
    hasStarted: boolean,
    userActivity: boolean,
    isActive: boolean,
    isFullScreen: boolean,
    videoId: any
}
export default function RedQuickVideo(props) {
    const [player, setPlayer] = React.useState(null);
    const [hasStarted, setHasStarted] = React.useState(false);
    const [currentTime, setCurrentTime] = React.useState(null);
    const [lastTime, setLastTime] = React.useState(null);
    const [duration, setDuration] = React.useState(null);
    const useDirectVideo = false;
    let {
        item,
        url,
        muted = true,
        playsInline = true,
        autoPlay,
        play
    } = props;
    const max_dim = 300;
    React.useEffect(() => {
        if (props.play !== undefined) {
            if (props.play) {
                player?.play();
            }
            else {
                player?.pause();
            }
        }
    }, [props.play, player])
    React.useEffect(() => {
        if (lastTime === null) {
            setLastTime(currentTime);
        }
        else if (duration - 1 <= currentTime) {
            if (props.onEnded) {
                props.onEnded(null);
            }
        }
    }, [currentTime])
    React.useEffect(() => {
        if (props.play) {
            if (player) {
                if (duration && currentTime && duration - 1 <= currentTime) {
                    console.log('player.seek')
                    player.seek(-currentTime);
                }
                else {
                    console.log('player.play')
                    player.play();
                }
            }
        }
        else {
            if (player) {
                console.log('player.pause')
                player.pause();
            }
        }
    }, [hasStarted, props.play])
    React.useEffect(() => {
        if (duration !== null) {
            if (props.onDuration) {
                console.log('player.onDuration')
                props.onDuration(duration);
            }
        }
    }, [duration])
    let video_items = url ? (<div className={props.containerCls} style={props.containerStyle}>
        <div onClick={() => {
            if (props.onClick) {
                props.onClick();
            }
        }} style={{
            objectFit: 'contain',
            // backgroundColor: 'honeydew',
            // padding: 3,
            ...(props.playerStyle || {}),
        }} >
            {useDirectVideo ? <video onDurationChange={(evt: any) => {
                if (evt?.duration) {
                    setDuration(evt?.duration);
                }
            }} onEnded={() => {
                props.onEnded();
            }} controls autoPlay onTouchStart={() => {
                console.log('touch start')
            }} muted={muted} src={url} style={{}}></video> : <Player
                loop ref={($player) => {
                    if ($player?.subscribeToStateChange) {
                        setPlayer($player)
                        $player.subscribeToStateChange((evt: RedQuickVideoState, prevState: RedQuickVideoState) => {
                            setCurrentTime(evt.currentTime);
                            if (evt.ended) {
                                if (props.onEnded) {
                                    props.onEnded(evt);
                                }
                            }
                            if (evt) {
                                setDuration(evt?.duration);
                            }
                            if (props.onStateChanged) {
                                props.onStateChanged(evt, prevState, $player);
                            }
                        });
                    }
                }}
                onDurationChange={(evt) => {
                    console.log(evt);
                }}
                playsInline={props.playsInline}
                src={url}
                autoPaused
                muted={props.muted === undefined || props.muted}
                autoPlay={autoPlay}
            >
                {props.disablePlayButton ? null : <BigPlayButton position="center" />}
                {props.disableBar ? <ControlBar disableDefaultControls={true} /> : <ControlBar autoHide={false} className="my-class" />}
            </Player>}
        </div>
        {props.coverVideo && <div className="video-cover"></div>}
    </div>) : <></>;


    return (
        <>{video_items}</>
    )
}